import { Component, OnInit } from '@angular/core';
import { LocalaccountService } from './localaccount.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonSubProductsHeroComponent } from 'src/app/shared/components/sub-products/sub-products-hero/hero.component';
import { CommonSubProductsLogosComponent } from 'src/app/shared/components/sub-products/logos/logos.component';
import { CommonSubProductsAlternateBlocksComponent } from 'src/app/shared/components/sub-products/alternate-blocks/alternate-blocks.component';
import { CommonSubProductsVideoComponent } from 'src/app/shared/components/sub-products/video-section/video.component';
import { CommonSubProductsCustomerStoryComponent } from 'src/app/shared/components/sub-products/customer-story/customer-story.component';
import { CommonSubProductsDiscoverDifferenceComponent } from 'src/app/shared/components/sub-products/discover-difference/discover-difference.component';
import { CommonSubProductsPricingComponent } from 'src/app/shared/components/sub-products/pricing/pricing.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';

@Component({
  selector: 'app-local-account',
  templateUrl: './local-account.component.html',
  styleUrls: ['./local-account.component.scss'],
  imports: [
    CommonSubProductsHeroComponent,
    CommonSubProductsLogosComponent,
    CommonSubProductsAlternateBlocksComponent,
    CommonSubProductsVideoComponent,
    CommonSubProductsCustomerStoryComponent,
    CommonSubProductsDiscoverDifferenceComponent,
    CommonSubProductsPricingComponent,
    CommonSubProductsWhitePaperComponent,
    CommonGetstartedComponent,
  ],
})
export class LocalAccountComponent implements OnInit {
  heroHeader:any;
  logosData:any;
  featureData1:any;
  featureData2:any;
  videoData:any;
  storyData:any;
  differenceData:any;
  pricingData:any;
  getStartedData:any;
  whitePaperData:any;
  constructor(
    private localaccountService: LocalaccountService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.localaccountService.getlocalAccountPageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo'][0].fields;
    if (data?.seoMetadataReference?.fields.title) {
      this.metaBody.title = data?.seoMetadataReference?.fields.title;
    } else {
      this.metaBody.title =
        'Verto: Cross-border payments platform for businesses';
    }
    if (data?.seoMetadataReference?.fields.description) {
      this.metaBody.description =
        data?.seoMetadataReference?.fields.description;
    } else {
      this.metaBody.description =
        'Verto: Cross-border payments platform for businesses across the globe.';
    }
    this.metaBody.type = 'Business Account';
    this.metaBody.url = this.getUrl;
    this.metaBody.image =
      data?.heroContentPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);

    // fetch Hero Data
    this.localaccountService.localAccountHero$.subscribe(data => {
      if (data != null) {
        this.heroHeader = {
          tagIcon: data?.tags[0]?.fields?.icon?.fields?.file?.url,
          iconTitle: data?.tags[0]?.fields?.icon?.fields?.title,
          tagName: data.tags[0].fields.tagText,
          header: data.title,
          image: data.image[0].fields.file.url,
          alt: data.image[0].fields.title,
          paragraph: data.content,
          button1: {
            text: data?.buttons?.[0]?.fields.buttonText,
            url: data?.buttons?.[0]?.fields.redirectLink,
            target: data?.buttons?.[0]?.fields.actionType,
          },
          button2: {
            text: data?.buttons?.[1]?.fields.buttonText,
            url: data?.buttons?.[1]?.fields.redirectLink,
            target: data?.buttons?.[1]?.fields.actionType,
          },
        };
      }
    });
    // fetch logos data
    this.localaccountService.localAccountCustomerStats$.subscribe(data => {
      if (data != null) {
        let imgData = data.image;
        this.logosData = {
          logos: imgData,
          header: data.title,
        };
      }
    });
    this.localaccountService.localAccountFeaturePanel1$.subscribe(data => {
      if (data != null) {
        this.featureData1 = data;
      }
    });
    this.localaccountService.localAccountFeaturePanel2$.subscribe(data => {
      if (data != null) {
        this.featureData2 = data;
      }
    });
    this.localaccountService.localAccountVideoPanel$.subscribe(data => {
      if (data != null) {
        this.videoData = data;
      }
    });
    this.localaccountService.localAccountCustomerStoryPanel$.subscribe(data => {
      if (data != null) {
        this.storyData = data;
      }
    });
    this.localaccountService.localAccountDiscoverDifferencePanel$.subscribe(
      data => {
        if (data != null) {
          this.differenceData = data;
        }
      }
    );
    this.localaccountService.localAccountWhitePaperPanel$.subscribe(data => {
      if (data != null) {
        this.whitePaperData = data;
      }
    });
    this.localaccountService.localAccountPricingPanel$.subscribe(data => {
      if (data != null) {
        this.pricingData = data;
      }
    });
    this.localaccountService.getStarted$.subscribe(data => {
      if (data != null) {
        this.getStartedData = {
          header: data.title,
          button1: {
            url: data?.buttons?.[0]?.fields.redirectLink,
            text: data?.buttons?.[0]?.fields.buttonText,
            target: data?.buttons?.[0]?.fields.actionType,
          },
          button2: {
            url: data?.buttons?.[1]?.fields.redirectLink,
            text: data?.buttons?.[1]?.fields.buttonText,
            target: data?.buttons?.[1]?.fields.actionType,
          },
        };
      }
    });
    this.posthogService.capturePageViewEvent('local_account');
  }
}
